var map = {
	"./ion-action-sheet-ios.entry.js": [
		426,
		65
	],
	"./ion-action-sheet-md.entry.js": [
		427,
		66
	],
	"./ion-alert-ios.entry.js": [
		428,
		57
	],
	"./ion-alert-md.entry.js": [
		429,
		58
	],
	"./ion-app_8-ios.entry.js": [
		430,
		51
	],
	"./ion-app_8-md.entry.js": [
		431,
		52
	],
	"./ion-avatar_3-ios.entry.js": [
		432,
		8
	],
	"./ion-avatar_3-md.entry.js": [
		433,
		9
	],
	"./ion-back-button-ios.entry.js": [
		434,
		10
	],
	"./ion-back-button-md.entry.js": [
		435,
		11
	],
	"./ion-backdrop-ios.entry.js": [
		436,
		12
	],
	"./ion-backdrop-md.entry.js": [
		437,
		13
	],
	"./ion-button_2-ios.entry.js": [
		438,
		67
	],
	"./ion-button_2-md.entry.js": [
		439,
		68
	],
	"./ion-card_5-ios.entry.js": [
		440,
		14
	],
	"./ion-card_5-md.entry.js": [
		441,
		15
	],
	"./ion-checkbox-ios.entry.js": [
		442,
		16
	],
	"./ion-checkbox-md.entry.js": [
		443,
		17
	],
	"./ion-chip-ios.entry.js": [
		444,
		18
	],
	"./ion-chip-md.entry.js": [
		445,
		19
	],
	"./ion-col_3.entry.js": [
		446,
		20
	],
	"./ion-datetime_3-ios.entry.js": [
		447,
		55
	],
	"./ion-datetime_3-md.entry.js": [
		448,
		56
	],
	"./ion-fab_3-ios.entry.js": [
		449,
		69
	],
	"./ion-fab_3-md.entry.js": [
		450,
		70
	],
	"./ion-img.entry.js": [
		451,
		21
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		452,
		22
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		453,
		23
	],
	"./ion-input-ios.entry.js": [
		454,
		24
	],
	"./ion-input-md.entry.js": [
		455,
		25
	],
	"./ion-item-option_3-ios.entry.js": [
		456,
		71
	],
	"./ion-item-option_3-md.entry.js": [
		457,
		72
	],
	"./ion-item_8-ios.entry.js": [
		458,
		73
	],
	"./ion-item_8-md.entry.js": [
		459,
		74
	],
	"./ion-loading-ios.entry.js": [
		460,
		26
	],
	"./ion-loading-md.entry.js": [
		461,
		27
	],
	"./ion-menu_3-ios.entry.js": [
		462,
		75
	],
	"./ion-menu_3-md.entry.js": [
		463,
		76
	],
	"./ion-modal-ios.entry.js": [
		464,
		53
	],
	"./ion-modal-md.entry.js": [
		465,
		54
	],
	"./ion-nav_2.entry.js": [
		466,
		64
	],
	"./ion-popover-ios.entry.js": [
		467,
		28
	],
	"./ion-popover-md.entry.js": [
		468,
		29
	],
	"./ion-progress-bar-ios.entry.js": [
		469,
		30
	],
	"./ion-progress-bar-md.entry.js": [
		470,
		31
	],
	"./ion-radio_2-ios.entry.js": [
		471,
		32
	],
	"./ion-radio_2-md.entry.js": [
		472,
		33
	],
	"./ion-range-ios.entry.js": [
		473,
		77
	],
	"./ion-range-md.entry.js": [
		474,
		78
	],
	"./ion-refresher_2-ios.entry.js": [
		475,
		59
	],
	"./ion-refresher_2-md.entry.js": [
		476,
		60
	],
	"./ion-reorder_2-ios.entry.js": [
		477,
		34
	],
	"./ion-reorder_2-md.entry.js": [
		478,
		35
	],
	"./ion-ripple-effect.entry.js": [
		479,
		36
	],
	"./ion-route_4.entry.js": [
		480,
		79
	],
	"./ion-searchbar-ios.entry.js": [
		481,
		80
	],
	"./ion-searchbar-md.entry.js": [
		482,
		81
	],
	"./ion-segment_2-ios.entry.js": [
		483,
		82
	],
	"./ion-segment_2-md.entry.js": [
		484,
		83
	],
	"./ion-select_3-ios.entry.js": [
		485,
		84
	],
	"./ion-select_3-md.entry.js": [
		486,
		85
	],
	"./ion-slide_2-ios.entry.js": [
		487,
		86
	],
	"./ion-slide_2-md.entry.js": [
		488,
		87
	],
	"./ion-spinner.entry.js": [
		489,
		37
	],
	"./ion-split-pane-ios.entry.js": [
		490,
		38
	],
	"./ion-split-pane-md.entry.js": [
		491,
		39
	],
	"./ion-tab-bar_2-ios.entry.js": [
		492,
		40
	],
	"./ion-tab-bar_2-md.entry.js": [
		493,
		41
	],
	"./ion-tab_2.entry.js": [
		494,
		42
	],
	"./ion-text.entry.js": [
		495,
		43
	],
	"./ion-textarea-ios.entry.js": [
		496,
		44
	],
	"./ion-textarea-md.entry.js": [
		497,
		45
	],
	"./ion-toast-ios.entry.js": [
		498,
		61
	],
	"./ion-toast-md.entry.js": [
		499,
		62
	],
	"./ion-toggle-ios.entry.js": [
		500,
		46
	],
	"./ion-toggle-md.entry.js": [
		501,
		47
	],
	"./ion-virtual-scroll.entry.js": [
		502,
		48
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 170;
module.exports = webpackAsyncContext;